module.exports = __webpack_public_path__ + "img/12-l.c46718b6.png";